import { render, staticRenderFns } from "./RolesManager.vue?vue&type=template&id=782a3b30&scoped=true&"
import script from "./RolesManager.vue?vue&type=script&lang=ts&"
export * from "./RolesManager.vue?vue&type=script&lang=ts&"
import style0 from "./RolesManager.vue?vue&type=style&index=0&id=782a3b30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782a3b30",
  null
  
)

export default component.exports